import type { Notation } from "../api/schemas";

/**
 * §5.K — L'UN DES SIX EMPLACEMENTS D'AFFICHAGE DE LA NOTE.
 * Tous doivent être protégés : sur un dossier sans matière, la plateforme
 * sortait 19,55/20 cote AAA. Une agence de notation ne délivre pas de cote
 * sans matière.
 *
 * Ce composant est le SEUL point d'affichage d'une note côté web : aucun écran
 * ne formate `noteGlobale` lui-même.
 */
export function AfficheNotation({ notation }: { notation: Notation }) {
  if (!notation.evaluable) {
    return (
      <div className="notation notation--non-evaluee" role="status">
        <div className="notation__cote">NON ÉVALUÉ</div>
        <p className="notation__motif">{notation.motif}</p>
        <p className="notation__consequence">Visa réservé — aucune cote ne peut être prononcée.</p>
      </div>
    );
  }

  return (
    <div className="notation">
      <div className="notation__anneau" style={{ ["--part" as string]: `${(notation.noteGlobale! / 20) * 100}%` }}>
        <span className="notation__note">{notation.noteGlobale!.toFixed(2)}</span>
        <span className="notation__sur">/ 20</span>
      </div>
      <div className="notation__cote">{notation.cote}</div>
      <ul className="notation__domaines">
        {notation.domaines.map((d) => (
          <li key={d.domaine}>
            <span className="notation__domaine-libelle">
              {d.domaine} · {d.libelle}
            </span>
            <span className="notation__barre">
              <span style={{ width: `${(d.note / 20) * 100}%` }} />
            </span>
            <span className="notation__domaine-note">
              {d.note.toFixed(0)}/20
              <em> ({(d.ponderation * 100).toFixed(0)} %)</em>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
